import { FACE_RELATIONS } from "enums";
import momIcon from "assets/images/CTAmodals/mother.png";
import fatherIcon from "assets/images/CTAmodals/father.png";
import partnerIcon from "assets/images/CTAmodals/partner.png";
import meIcon from "assets/images/CTAmodals/me.png";
import defaultIcon from "assets/images/CTAmodals/default.png";

export const MODAL_CONTENT = {
  title: {
    [FACE_RELATIONS.mother]: "Moms rock!",
    [FACE_RELATIONS.father]: "Super Dad!",
    [FACE_RELATIONS.partner]: "Partner Up!",
    [FACE_RELATIONS.me]: "Me, Myself & I!",
    [FACE_RELATIONS.family]: "Faces = Fun!",
    [FACE_RELATIONS.friend]: "Faces = Fun!",
    [FACE_RELATIONS.pet]: "Faces = Fun!",
  },
  description: {
    [FACE_RELATIONS.mother]: "Add your mother's face, and JibJab will have Mother's Day Ecards ready to make her day!",
    [FACE_RELATIONS.father]:
      "Add your father's face, and JibJab will have Father's Day Ecards ready to make him chuckle.",
    [FACE_RELATIONS.partner]: "Add your Partner's face and we'll prepare Videos and Ecards just for them!",
    [FACE_RELATIONS.me]: 'Add your face to "Me" and we\'ll prepare Videos and Ecards just for you!',
    [FACE_RELATIONS.friend]: "Adding family and friends makes JibJab even more fresh and fun!",
    [FACE_RELATIONS.family]: "Adding family and friends makes JibJab even more fresh and fun!",
    [FACE_RELATIONS.pet]: "Adding family and friends makes JibJab even more fresh and fun!",
  },
  img: {
    [FACE_RELATIONS.mother]: momIcon,
    [FACE_RELATIONS.father]: fatherIcon,
    [FACE_RELATIONS.partner]: partnerIcon,
    [FACE_RELATIONS.me]: meIcon,
    [FACE_RELATIONS.friend]: defaultIcon,
    [FACE_RELATIONS.family]: defaultIcon,
    [FACE_RELATIONS.pet]: defaultIcon,
  },
};
